import {createStyles} from '@material-ui/core';

export const style = createStyles({
  container: {
    height: '100%',
    overflowY: 'auto',
  },
});
